module.exports = __webpack_public_path__ + "img/grand-hotel-tremezzo_0.eaf75581.jpg";